// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"b9-z"};